import { banners as EnUsBanner } from '../en-us/banners';
import { AgResourceLanguage } from '../types';

export const banners: AgResourceLanguage['banners'] = {
  ...EnUsBanner,
  gift: {
    ...EnUsBanner.gift,
    title: 'Skicka en gåva till vänner och familj',
    description: 'Nu kan dina nära och kära prova AG1 med gåvan av daglig grundläggande näring.',
    iconAccessibleName: 'Gåva',
    imageAccessibleName: 'Gåva',
    buttonCloseLabel: 'Stäng',
    buttonShopLabel: 'Handla Gåvor'
  },
  paymentMethod: {
    ...EnUsBanner.paymentMethod,
    title: 'Saknad betalningsmetod',
    description:
      'Lägg till en betalningsmetod till ditt abonnemang för att fortsätta ta emot abonnemangsbeställningar.',
    addCtaBtnLabel: 'Lägg till nu',
    updateCtaBtnLabel: 'Uppdatera nu'
  },
  stockBanner:
    'Produkter i din nästa leverans är för närvarande slut i lager och kommer inte att skickas. Slut i lager-artiklar är exkluderade från din ordertotalsumma.',
  upcomingOrderBanner: {
    preparing: 'Förbereds',
    shipped: 'Skickad',
    delivered: 'Levererad',
    preparingDescription: 'Vi förbereder din beställning.',
    shippedDescription: 'Din nuvarande beställning är på väg.',
    deliveredDescription: 'Hurra! Du har fått AG1.',
    orderDetailsLink: 'Visa Orderdetaljer',
    trackingLink: 'Visa Spårningsstatus'
  },
  cookies: {
    ...EnUsBanner.cookies,
    text: 'Vi använder tredjepartscookies och spårningsteknologier som samlar in information om din användning av webbplatsen. Dessa tredje parter kan använda din information för egna syften, enligt vad som beskrivs i vår ',
    link: 'Integritetspolicy.'
  },
  promotionalBanner: {
    ...EnUsBanner.promotionalBanner,
    promotionMessage: 'Fantastiskt värde',
    title: 'Mer av det goda',
    descriptionPart1: 'Ändra ditt abonnemang till 2 påsar och få dem för $74.50 styck',
    descriptionPart2:
      ' — perfekt för par, familjer och mycket aktiva medlemmar som vill ha en extra skopa AG1 varje dag.',
    disclaimerFull:
      'Det är alltid bäst att rådgöra med din vårdgivare för att avgöra vilken näringsmix som är bäst för dig.',
    disclaimerShort: 'Rådgör med din vårdgivare för att avgöra den bästa näringsnivån för dig.',
    buttonText: 'Lägg till en Påse'
  },
  offerSoldOut: 'Detta erbjudande är slutsålt',
  offerVariantsSoldOut: {
    soldOut_one: '{{soldOutProducts}} är slutsåld',
    soldOut_other: '{{soldOutProducts}} är slutsålda'
  }
};
